// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__cAB9i","footer":"ModalError_footer__1j82O"};